// @ts-nocheck

export const localeCodes =  [
  "en"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/bdf7cf65" /* webpackChunkName: "config_i18n_46options_46ts_bdf7cf65" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US"
  }
]

